<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <CRow>
      <CCol col="12">
        <ChapterSelect
          :funcCountChat="countDefaultChat"
          :funcRoute="funcRoute"
          :content="content"
          :mainContent="show"
          :chapterProgress="chapterProgress"
          :pageCode="pageCode"
          :checkExam="checkExam"
          :loading="loading"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ChapterSelect from '../../components/template/Chinese1/ChapterSelect';
import {mapGetters} from 'vuex';
import '../../assets/scss/_chineseStyle.scss';

export default {
  components: {ChapterSelect},
  name: 'HP02',
  data() {
    return {
      show: {},
      content: [],
      Intro: [],
      popUpImage: [],
      popUpImageTwo: [],
      type: '',
      CheckFirstPage: 'first',
      code: '',
      CheckWidth: window.innerWidth.toString(),
      defaultChat: false,
      checkAnswer: true,
      courseCode: '',
      chapterProgress: {},
      pageCode: '',
      checkExam: [],
      courseSection: '',
      startTime: '',
      loading: true,
    };
  },

  computed: {
    ...mapGetters({
      allCourse: 'template/getTemplateContent',
      getCourseUserProgress: 'courses/getCourseChapterAndProgress',
    }),
  },
  watch: {
    allCourse: function (val) {
      (this.loading = true), (this.show = val);
      let payload = {
        code: this.courseCode,
        parameters: this.courseCode,
        templateCode: this.allCourse.codeTemplate,
        section: this.$store.getters['necessary/getUserCourseSection'],
      };
      // console.log("payload =>",payload);
      this.$store.dispatch('courses/fetchProgressChapter', payload);
    },
    getCourseUserProgress: function (val) {
      this.chapterProgress = val;
      console.log(this.chapterProgress, 'chapter progress');

      if (this.chapterProgress !== {}) {
        this.loading = false;
      }
    },
  },
  mounted() {},
  created() {
    this.onLoadCourse();
    this.startTime = this.$helpers.getDateFormat();
  },

  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkWidth() {
      if (this.CheckWidth > 500) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 500) {
        return 'container-chinese-card-mobile';
      }
    },
    onLoadCourse() {
      this.$store.commit('courses/setCourseQuizPermissionZero');
      this.courseCode = this.$store.getters['necessary/getLerningCourse']._id;
      this.pageCode = `HP02-` + this.$route.params.id;
      let body = {};
      body.code = this.courseCode;
      body.templateCode = `HP02-` + this.$route.params.id;
      this.$store.dispatch('template/fetchContent', body);
    },
    funcRoute(tempId) {
      let body = this.$helpers.setChineseUrl(tempId);
      this.$router.push(body);
    },
    closeModal() {
      this.openModalConver = !this.openModalConver;
    },
    countDefaultChat() {
      return (this.defaultChat = true);
    },
  },
};
</script>

<style>
.displayNone {
  display: None;
}

.displayBlock {
  display: block;
}
</style>
